function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
}
function headerHeight() {
  if (document.body.contains(document.querySelector('[data-site-header]'))) {
    const headerHeight =
      document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
    return headerHeight;
  } else {
    return;
  }
}
function cartFooter() {
  const cartFooterHeight =
    document.querySelector('.drawer__footer').offsetHeight;
  return cartFooterHeight;
}
function announcementHeight() {
  if (document.body.contains(document.querySelector('.announcement-bar'))) {
    const announcementHeight =
      document.querySelector('.announcement-bar').offsetHeight;
    if (announcementHeight == 0) {
      return 36;
    } else {
      return announcementHeight;
    }
  } else {
    return 0;
  }
}

function halfPageOffset() {
  if (document.body.contains(document.querySelector('.page-width'))) {
    const container = document.querySelector('.page-width');
    const offset = container.offsetLeft;
    return offset;
  }
}

document.documentElement.style.setProperty(
  '--window-height',
  windowHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--header-height',
  headerHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--half-page-offset',
  halfPageOffset() + 'px'
);
document.documentElement.style.setProperty(
  '--cart-footer-height',
  cartFooter() + 'px'
);
document.documentElement.style.setProperty(
  '--announcement-height',
  announcementHeight() + 'px'
);

window.addEventListener(
  'resize',
  debounce(function () {
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--cart-footer-height',
      cartFooter() + 'px'
    );
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--half-page-offset',
      halfPageOffset() + 'px'
    );

    const sliders = document.querySelectorAll('.bd-slider');
    sliders.forEach((slider) => {
      const flkty = Flickity.data(slider);
      console.log('resize slider and reposition');
      flkty.destroy();
      makeSliders();
    });

    //check overflow containers
    checkOverflow();

  }, 50)
);

// URL PARAMETERS
function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
}

/************ Smooth Scroll  ****************/

document
  .querySelectorAll(
    'a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target])'
  )
  .forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('scroll to ', e.target);
      const offset = headerHeight() * -1.25;
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = anchor.hash;

        target = target.length
          ? target
          : document.querySelector(`[name="${this.hash.slice(1)}"]`);
        console.log(offset, 'OFFSET');

        if (target.length) {
          console.log(target, 'TARGET');

          const elementId = decodeURIComponent(target.replace('#', ''));
          const element = document.getElementById(elementId);
          console.log(element, 'ELEMENT');
          console.log(elementId, 'ELEMENT ID');

          console.log('element', element);
          window.scrollTo({
            top: getOffsetTop(element) + offset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    });
  });

function getOffsetTop(element) {
  return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
}




const scrollContainers = document.querySelectorAll('[data-horz-scroll]');


function checkOverflow() {
  scrollContainers.forEach((scrollContainer) => {
    if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
      scrollContainer.classList.add('overflowing');
    } else {
      scrollContainer.classList.remove('overflowing');
    }
  });
}
 
checkOverflow();
scrollContainers.forEach((scrollContainer) => {
  let isDragging = false;
  let startX;
  let scrollLeft;

  let velocity = 0;
  let rafId;

  function updateScroll() {
    if (!isDragging) return;
    scrollContainer.scrollLeft -= velocity;
    velocity *= 0.95; // Add friction
    if (Math.abs(velocity) > 0.75) {
      rafId = requestAnimationFrame(updateScroll);
    }
  }

  scrollContainer.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
    velocity = 0;
    cancelAnimationFrame(rafId);
  });

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    velocity = (x - startX) * 0.75; // Adjust speed
    startX = x;
    requestAnimationFrame(updateScroll);
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDragging = false;
  });

  /*
// Touch support
scrollContainer.addEventListener("touchstart", (e) => {
    isDragging = true;
    startX = e.touches[0].pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
});

scrollContainer.addEventListener("touchend", () => {
    isDragging = false;
});

scrollContainer.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll speed
    scrollContainer.scrollLeft = scrollLeft - walk;
});
*/
});
